import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-reset-password',
  standalone: false,
  templateUrl: './reset-password.page.html',
  styleUrl: './reset-password.page.css',
})
export class ResetPasswordPage implements OnInit {
  token = '';
  password = '';
  confirmPassword = '';
  showPassword = false;
  showConfirmPassword = false;
  loading = false;
  errorMessage = '';
  success = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.token =
      this.route.snapshot.queryParamMap.get('token') ||
      this.route.snapshot.queryParamMap.get('password_reset_token') ||
      '';

    if (!this.token) {
      this.errorMessage =
        'Invalid or missing password reset token. Please request a new password reset link.';
    }
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  toggleShowConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  async submitResetPassword() {
    this.errorMessage = '';

    if (!this.token) {
      this.errorMessage =
        'Invalid or missing reset token. Please request a new password reset link.';
      return;
    }

    if (!this.password || this.password.length < 8) {
      this.errorMessage = 'Password must be at least 8 characters long.';
      return;
    }

    if (this.password !== this.confirmPassword) {
      this.errorMessage = 'Passwords do not match.';
      return;
    }

    this.loading = true;

    try {
      await this.authService.resetPassword(this.token, this.password);
      this.success = true;
      setTimeout(() => {
        if (this.authService.isLoggedIn()) {
          this.router.navigate(['/dashboard/home']);
        } else {
          this.router.navigate(['/auth/login']);
        }
      }, 1500);
    } catch (err: any) {
      console.error('Password reset failed:', err);
      this.errorMessage =
        err?.error_message ||
        err?.message ||
        'Password reset failed. The link may have expired or is invalid.';
    } finally {
      this.loading = false;
    }
  }
}
